import { Link } from 'react-router-dom'
import { AsciiTerrain } from '../components/AsciiTerrain'
import './Library.css'
import './WorksHero.css'

const Library = () => {
  const items = [
    {
      id: 'sonic-pi',
      title: 'Sonic Pi Sessions',
      description: 'Live coding patches for rhythm and texture',
      gradient: 'linear-gradient(135deg, #071913, #0f3a32)',
      imageUrl: '/images/pi.jpg',
    },
    {
      id: 'strudel',
      title: 'Strudel Notebooks',
      description: 'Pattern notebooks for fast iteration',
      gradient: 'linear-gradient(135deg, #071820, #17445b)',
      imageUrl: '/images/strudel.jpg',
    },
    {
      id: 'playtronica',
      title: 'Playtronica Mappings',
      description: 'Touch and motion mapped to sound',
      gradient: 'linear-gradient(135deg, #16110b, #3a2c12)',
      imageUrl: '/images/playtronica.jpg',
    },
    {
      id: 'patches',
      title: 'Patch Diagrams',
      description: 'Signal flow maps you can rebuild',
      gradient: 'linear-gradient(135deg, #071a16, #164233)',
      imageUrl: '/images/patch.jpg',
    },
    {
      id: 'stems',
      title: 'Stem Library',
      description: 'Clean stems for remixing and resampling',
      gradient: 'linear-gradient(135deg, #09141e, #1a2937)',
      imageUrl: '/images/stem.jpg',
    },
    {
      id: 'starter-kit',
      title: 'Starter Patch Kit',
      description: 'Minimal blocks for modular systems',
      gradient: 'linear-gradient(135deg, #08131c, #243447)',
      imageUrl: '/images/kit.jpg',
    },
  ]

  return (
    <main className="main-content">
      <div className="library-hero-section">
        <AsciiTerrain />
        <div className="works-hero-content">
          <h1 className="works-hero-title">library</h1>
        </div>
      </div>

      <div className="library-content black-background">
        <div className="library-intro">
          <p className="library-intro-text">
            A curated archive of tools and artifacts from sessions and experiments. Built to remix, rebuild, and perform.
          </p>
        </div>

        <div className="library-grid">
          {items.map((item) => (
            <Link key={item.id} to={`/library/${item.id}`} className="library-item">
              <div className="library-item-image" style={{ backgroundImage: item.gradient }}>
                <img src={item.imageUrl} alt={item.title} />
                <div className="library-item-overlay">
                  <span className="library-item-explore">explore</span>
                </div>
              </div>
              <div className="library-item-content">
                <h3 className="library-item-title">{item.title}</h3>
                <p className="library-item-description">{item.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  )
}

export default Library
